<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED"><span class="ePub-I">To Muriel LeFave, who inspired Lillian Frost and who loved a mystery</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6c470563